import f from "../../funcs";
import Events from "../../classes/Events";
import NotifyView from "./view/NotifyView";
import "css!apps/Notification/style";


let Notification = f.CreateClass("Notification", {
    onClick: null
}, Events);

Notification.prototype.init = function(params) {
    params = f.deepMixin({
        model: null
    }, params);
    this.time = Date.now();
    this.params = params;
    this.onClick = params.click || null;
    this.onClose = params.close || null;

    this.model = params.model;
    this.initView();
};

Notification.prototype.initView = function() {
    this.view = new NotifyView({
        el: this.$element,
        model: this.model
    });
    this.view.render();
    this.view.on("close", () => {
        this.close();
    });

    this.view.on("click", (e) => {
        if ( f.isFunction(this.onClick) ) {
            let result = this.onClick(e, this.model);
            if ( result === false ) {
                return;
            }
        }
        this.close();
    });

    this.$element = this.view.$el;

    this.listenTo($(window), "mousemove", (e) => {
        if ( this.$element.hasChild(e.target) ) {
            this.$element.addClass("hover");
            this.time = Date.now();
        } else {
            this.$element.removeClass("hover");
        }
    });
};

Notification.prototype.show = function(callback) {
    if ( !f.isFunction(callback) ) {
        callback = function() {};
    }

    if ( this.isShowed ) {
        return callback();
    }

    this.isShowed = true;

    this.$element.show().addClass("opened");
    this.view.scroll.setOverview({
        width: 0,
        height: this.view.ui.$overview[0].offsetHeight
    });
    this.view.scroll.setViewport({
        width: 0,
        height: this.view.ui.$viewport[0].offsetHeight
    });
    this.view.scroll.update();

    setTimeout(() => {

        if ( f.isFunction(this.onShow) ) {
            this.onShow();
        }

        this.trigger("show");
        callback();
    }, 300);
};

Notification.prototype.hide = function(callback) {
    let closeBox = document.querySelector(".Notification--closeAll");
    let openedNoty = $(".Notification.opened");

    if ( openedNoty.length < 3 && closeBox ) {
        closeBox.outerHTML = "";
    }

    if ( !f.isFunction(callback) ) {
        callback = function() {};
    }

    if ( !this.isShowed ) {
        return callback();
    }
    this.isShowed = false;

    this.$element.removeClass("opened");
    setTimeout(() => {

        if ( f.isFunction(this.onHide) ) {
            this.onHide();
        }
        this.$element.hide();

        this.trigger("hide");
        callback();
    }, 300);
};

Notification.prototype.close = function() {
    this.hide(() => {
        this.view.destroy();
        this.$element.remove();

        if ( f.isFunction(this.onClose) ) {
            this.onClose();
        }

        this.trigger("close");
    }, 300);
};

export default Notification;
